// Playmore winter homepage behaviour.
// 1) Muted loop videos load only when near the viewport and pause off-screen;
//    above-the-fold (data-eager) videos wait for window load so they never compete with LCP.
// 2) Shop-the-look gallery (syve style): centre model + neighbours, click to rotate.
// 3) Desktop hover trail of small real photos over [data-trail] (Vikki UI "Northbound").
(() => {
  if (window.__pmw) return; window.__pmw = 1;
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const save = navigator.connection && navigator.connection.saveData;

  // 1) videos
  const io = (still || save) ? null : new IntersectionObserver((es) => es.forEach((e) => {
    const v = e.target;
    if (!v.offsetParent) return; // hidden on this breakpoint: never download
    if (e.isIntersecting) { if (!v.src) v.src = v.dataset.src; v.play().catch(() => {}); } else v.pause();
  }), { rootMargin: '200px 0px' });
  // video covers: a <video poster> downloads at page open no matter how far down it sits, so set it ~a screen ahead instead
  const pio = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return; // whole section at once, so covers in sideways rows are ready before they're swiped in
    const box = e.target.closest('.shopify-section') || e.target.parentNode;
    box.querySelectorAll('video[data-lazy-poster]').forEach((v) => { if (!v.poster) v.poster = v.dataset.poster; pio.unobserve(v); });
  }), { rootMargin: '1000px 0px' }) : null;
  const initPosters = () => document.querySelectorAll('video[data-lazy-poster]').forEach((v) => {
    if (v.__pmp) return; v.__pmp = 1;
    pio ? pio.observe(v) : (v.poster = v.dataset.poster);
  });
  const initVideos = () => io && document.querySelectorAll('video.pmw-video').forEach((v) => {
    if (v.__pmw) return; v.__pmw = 1;
    if (v.hasAttribute('data-eager') && document.readyState !== 'complete') addEventListener('load', () => io.observe(v), { once: true });
    else io.observe(v);
  });

  // 3) hover trail
  const initTrail = () => {
    if (still || !matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
    document.querySelectorAll('[data-trail]').forEach((el) => {
      if (el.__pmw) return; el.__pmw = 1;
      const srcs = el.dataset.trail.split('|').filter(Boolean); if (!srcs.length) return;
      srcs.forEach((s) => { const i = new Image(); i.src = s; }); // warm cache after first hover only
      let k = 0, lx = 0, ly = 0;
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
        if (Math.hypot(x - lx, y - ly) < 70) return; lx = x; ly = y;
        const img = document.createElement('img');
        img.src = srcs[k++ % srcs.length]; img.alt = ''; img.className = 'pmw-trail';
        img.style.left = x + 'px'; img.style.top = y + 'px'; img.style.setProperty('--rot', ((k % 5) - 2) * 3 + 'deg');
        el.appendChild(img);
        setTimeout(() => img.classList.add('out'), 700);
        setTimeout(() => img.remove(), 1300);
      });
    });
  };

  const init = () => { initPosters(); initVideos(); initTrail(); };
  init();
  document.addEventListener('shopify:section:load', init);
})();
